import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put } from 'redux-saga/effects';
import { reducePolicyLogs } from '../../actions/policy/reducePolicyLogs';

export function* getLogsSaga(action) {
    try {
        yield put(reduceLoading({ code: 'getLogs', value: true }));
        const session = yield getSessionSaga();
        const response = yield call(
            fetch,
            `/api/log?referenceCode=${action.payload.referenceCode}&productCode=${action.payload.productCode}`,
            {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    Accept: 'application/json',
                    Authorization: session.authenticationToken.token,
                    'Content-Type': 'application/json',
                },
            },
        );
        const result = yield call([response, 'json']);
        yield put(reduceOperation(result.operation));
        if (!result.operation.status) {
            yield put(reduceLoading({ code: 'getLogs', value: false }));
            return;
        }
        yield put(reducePolicyLogs(result.apiLogs));
        yield put(reduceLoading({ code: 'getLogs', value: false }));
        return;
    } catch (error) {
        console.log('Error while calling Get API Logs - ', error);
        yield put(reduceLoading({ code: 'getLogs', value: false }));
        return;
    }
}
